import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getDietImageUrl } from '../utils/imageUtils';

const DietCard = ({ diet, onClick }) => {
    // Replace spaces with hyphens or underscores
    const imageName = diet.name.replace(/\s+/g, '-'); // or use '_' instead of '-'
    const dietImageUrl = getDietImageUrl(imageName);

    useEffect(() => {
        // console.log('looking for image:', `/images/dietImages/${imageName}.jpg`);
        // console.log('diet object:', JSON.stringify(diet));
    }, []);

    // If onClick is provided, use it instead of Link
    if (onClick) {
        return (
            <div onClick={() => onClick(diet)} className="diet-card" style={{ cursor: 'pointer' }}>
                <img
                    className="diet-card-image"
                    src={dietImageUrl}
                    alt={diet.name}
                />
                <div className="diet-card-content">
                    <h3 className="recipe-filter-name">{diet.name}</h3>
                </div>
            </div>
        );
    }

    return (
        <Link to={`/diet/${diet.name}`} state={{ diet: diet}} className="diet-card">
            <img
                className="diet-card-image"
                src={dietImageUrl}
                alt={diet.name}
            />
            <div className="diet-card-content">
                <h3 className="recipe-filter-name">{diet.name}</h3>
            </div>
        </Link>
    );

}

export default DietCard;